// REACT, REACT ROUTER
import React, { useContext, RefObject, useRef, useEffect } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'

// ASSETS
import Waze from 'Assets/Footer/waze.svg'
import Banner from 'Assets/Footer/banner.jpg'

// ESTILOS
import Styles from './Footer.module.css'

// CONTEXTO
import MainContext from 'Context/MainContext'
import ShowBook from 'Components/showBook/ShowBook'

const Footer: React.FC<RouteComponentProps> = (props: RouteComponentProps) => {
	// STRINGS
	const { footer, services } = useContext(MainContext).lang

	// REFERENCIAS
	const mapRef: RefObject<HTMLIFrameElement> = useRef(null)

	// PATH
	const path: string = props.history.location.pathname.substring(1)

	// CAMBIAR REF
	useEffect(() => {
		setTimeout(() => {
			if (mapRef.current)
				mapRef.current.src =
					'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15427.366258919783!2d-91.5193939!3d14.8341475!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb01217b25d480722!2sVilla%20de%20Don%20Andr%C3%A9s!5e0!3m2!1ses-419!2sgt!4v1592933223906!5m2!1ses-419!2sgt'
		}, 5000)
	}, [])

	return (
		<footer
			className={Styles.footer}
			style={{
				display: path === 'reservaciones' ? 'none' : 'block',
			}}>
			<div className={Styles.linksSection}>
				<div className={Styles.linksContainer}>
					<ul>
						<li className={Styles.listItem}>
							<a
								target='_blank'
								rel='noopener noreferrer'
								className={Styles.link}
								href='https://www.google.com/maps/dir//hotel+villa+de+don+andres/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x858e97fe3ff5ca4b:0xb01217b25d480722?sa=X&ved=2ahUKEwjH7MWBvZjqAhUsWN8KHYIpBSUQ9RcwDnoECBQQEA'
								title='Mapa'>
								<i
									style={{ color: 'var(--yellow)' }}
									className={`${Styles.sep} lni lni-map-marker`}
								/>
								{footer.maps}
							</a>
						</li>
						<li className={Styles.listItem}>
							<a
								className={Styles.link}
								title={services.contact.email}
								href={`mailto:${services.contact.email}`}>
								<i className={`${Styles.sep} lni lni-envelope`} /> {services.contact.email}
							</a>
						</li>
						<li className={Styles.listItem}>
							<a
								target='_blank'
								rel='noopener noreferrer'
								className={Styles.link}
								href={`https://api.whatsapp.com/send?phone=${services.contact.phone_1
									.replace('-', '')
									.replace(' ', '')
									.replace(
										'+',
										''
									)}&text=%C2%A1Hola!%20Me%20gustar%C3%ADa%20reservar%20una%20habitaci%C3%B3n%20en%20Villa%20de%20Don%20Andr%C3%A9s.`}
								title={services.contact.phone_1}>
								<i className={`${Styles.sep} lni lni-whatsapp`} />{' '}
								{`${services.contact.phone_1} / `}
							</a>
							<a
								target='_blank'
								rel='noopener noreferrer'
								className={Styles.link}
								href={`https://api.whatsapp.com/send?phone=${services.contact.phone_2
									.replace('-', '')
									.replace(' ', '')
									.replace(
										'+',
										''
									)}&text=%C2%A1Hola!%20Me%20gustar%C3%ADa%20reservar%20una%20habitaci%C3%B3n%20en%20Villa%20de%20Don%20Andr%C3%A9s.`}
								title={services.contact.phone_2}>
								{services.contact.phone_2}
							</a>
						</li>
					</ul>
					<ul className={Styles.social}>
						<li>
							<span className={Styles.dot}>></span>
							<ShowBook name={footer.history} style={{}} type='history' />
						</li>
						<li>
							<span className={Styles.dot}>></span> {footer.follow}
							<ul>
								<li>
									<a
										aria-label='Instagram'
										target='_blank'
										rel='noopener noreferrer'
										href='https://www.instagram.com/villadedonandres/'>
										<i className='lni lni-instagram' />
									</a>
								</li>
								<li>
									<a
										aria-label='Facebook'
										target='_blank'
										rel='noopener noreferrer'
										href='https://www.facebook.com/villadonandres/'>
										<i className='lni lni-facebook' />
									</a>
								</li>
								<li>
									<a
										aria-label='Waze'
										target='_blank'
										rel='noopener noreferrer'
										href='https://www.waze.com/ul?place=ChIJGQzBSXGiiYUR43OBIOGb8GY&ll=14.65189790%2C-90.50087380&navigate=yes'>
										<img src={Waze} alt='Waze icon' />
									</a>
								</li>
							</ul>
						</li>
						<li>
							<span className={Styles.dot}>></span>
							<span>{footer.cookies}</span>
						</li>
					</ul>
				</div>
				<iframe ref={mapRef} title='Map' frameBorder='0' className={Styles.map} />
			</div>
			<div className={Styles.banner}>
				<img src={Banner} alt='Banner' />
			</div>
			<div className={Styles.bottom}>
				<span>{footer.rights}</span>
			</div>
		</footer>
	)
}

export default withRouter(Footer)
